import type { InputProps } from '@farmersdog/corgi-x';
import { FormControl, Input } from '@farmersdog/corgi-x';

import type { ChangeEvent } from 'react';

export interface EmailInputProps extends Omit<InputProps, 'ref'> {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  validationMessage: string;
}

export function EmailInput({
  validationMessage,
  value,
  onChange,
  className,
  ...props
}: EmailInputProps) {
  return (
    <FormControl
      politeness="polite"
      className={className}
      message={validationMessage}
      invalid={Boolean(validationMessage)}
    >
      <Input
        {...props}
        autoComplete="email"
        inputMode="email"
        label="Email"
        name="email"
        type="email"
        value={value}
        onChange={onChange}
      />
    </FormControl>
  );
}
